// extracted by mini-css-extract-plugin
export default {"collect-group-btn":"index_collect-group-btn__H+xUj"};